import { createSlice } from '@reduxjs/toolkit';

const initialstatusportalsState = {
  names: [],
};

const statusportalsSlice = createSlice({
  name: 'statusportals',
  initialState: initialstatusportalsState,
  reducers: {
    onInitialStatusPortals(state, action) {
      const portalId = action.payload.portalId;
      const status = action.payload.status;
      if (state.names.includes(portalId)) {
        state[portalId].data = status;
        state[portalId].isLoaded = true;
        state[portalId].Error = null;
      } else {
        state[portalId] = {
          data: status,
          isLoaded: true,
          Error: null
        };
        state.names = [...state.names, portalId];
      }
    },

    onSetError(state, action) {
      const portalId = action.payload.portalId;
      const status = action.payload.status;

      if (state.names.includes(portalId)) {
        state[portalId].Error = status;
        state[portalId].isLoaded = true;
        state[portalId].data = [];
      } else {
        state[portalId] = {
          data: [],
          isLoaded: true,
          Error: status
        };
        state.names = [...state.names, portalId];
      }
    },

    onSetLoaded(state, action) {
      const portalId = action.payload.portalId;
      const status = action.payload.status;

      if (state.names.includes(portalId)) {
        state[portalId].isLoaded = status;
      } else {
        state[portalId] = {
          data: [],
          isLoaded: status,
          Error: null
        };
        state.names = [...state.names, portalId];
      }
    }
  },
});

export const statusportalsActions = statusportalsSlice.actions;
export default statusportalsSlice.reducer;